module.exports = __webpack_public_path__ + "media/images/firsttime_header01_sp-9bb09498e8f9bedaa148cc6908323bd8.png";